import { lazy, Suspense } from 'react'
import { createBrowserRouter, Outlet } from 'react-router-dom'
import { Layout } from 'src/layouts/Layout'
import UserLayout from 'src/layouts/UserLayout'
import { ModuleNameSyncer } from '@/layouts/ModuleNameSyncer'
import coreRoutes from '@/modules/core/routes'
import { RouterErrorBoundary } from '@/modules/routes'
import wmsRoutes from '@/modules/wms/routes'

const LandingPage = lazy(() => import('@/modules/root/clusters/landing/pages/LandingPage'))
const LoginPage = lazy(() => import('@/modules/root/clusters/login/components/PageLogin'))
const ConfirmAOPage = lazy(() => import('@/modules/public/confirm-ao'))
const DeliveryConfirmationPage = lazy(() => import('@/modules/public/delivery-confirmation'))
const ArrivalOrderPrintQRPage = lazy(() => import('@/modules/public/arrival-order-print-qr'))
const NotFoundPage = lazy(() => import('@/modules/error/pages/404'))
const Error401Page = lazy(() => import('@/modules/error/pages/401'))
const Error500Page = lazy(() => import('@/modules/error/pages/500'))

import Spinner from 'src/@core/components/spinner'

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Suspense fallback={<div>Loading...</div>}>
          <LandingPage />
        </Suspense>
      </Layout>
    )
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LoginPage />
      </Suspense>
    )
  },
  {
    path: '/public',
    children: [
      {
        path: 'confirm-delivery',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ConfirmAOPage />
          </Suspense>
        )
      },
      {
        path: 'delivery-confirmation',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <DeliveryConfirmationPage />
          </Suspense>
        )
      },
      {
        path: 'arrival-order-print-qr',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ArrivalOrderPrintQRPage />
          </Suspense>
        )
      }
    ]
  },
  {
    element: (
      <Layout>
        <UserLayout>
          <ModuleNameSyncer />
          <Suspense fallback={<Spinner sx={{ height: 'auto', minHeight: '60vh' }} />}>
            <Outlet />
          </Suspense>
        </UserLayout>
      </Layout>
    ),
    errorElement: <RouterErrorBoundary />,
    children: [
      {
        path: '/solutions/core',
        handle: { name: 'Core System' },
        children: coreRoutes
      },
      {
        path: '/solutions/wms',
        handle: { name: 'Warehouse Management System' },
        children: wmsRoutes
      },
      {
        path: '/core',
        handle: { name: 'Core System' },
        children: coreRoutes
      },
      {
        path: '/wms',
        handle: { name: 'Warehouse Management System' },
        children: wmsRoutes
      }
    ]
  },
  { path: '/401', element: <Error401Page /> },
  { path: '/500', element: <Error500Page /> },
  { path: '/404', element: <NotFoundPage /> },
  { path: '*', element: <NotFoundPage /> }
])
